// Public news: plain fetches (no login token) so every visitor gets the
// same published posts; previews of drafts go through api() with the token.
export async function fetchPosts(limit = 12, page = 1) {
  const r = await fetch(`/api/posts?limit=${limit}&page=${page}`, { cache: 'no-cache' });
  if (!r.ok) throw new Error('posts');
  return r.json();
}
export const postDate = (iso, lang) => (iso ? new Intl.DateTimeFormat(lang === 'en' ? 'en-CA' : 'fr-CA', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'America/Montreal' }).format(new Date(iso)) : '');
